import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, ActivatedRouteSnapshot, Route } from '@angular/router';
import { ConfigService } from '../Services/ConfigService';

@Injectable()
export class LoggedInAuthGuard implements CanActivate, CanLoad {

	constructor(public configData: ConfigService) { }

    canLoad(route: Route): boolean {
        return this.checkAccess();
	}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        return this.checkAccess();
    }

    checkAccess() :boolean {
        return this.configData.AppConfig.me != "";
    }
}